module.exports = __webpack_public_path__ + "src/assets/img/share/tips/pleasant/319dc10256fd873cccbdaba2187c66d4.png";